@if (agent) {
    <section class="agpr-agentSummary">
        <agpr-panel header="AutomationAgents.agent.summary.information">
            <div class="agpr-definitionList">
                <div class="agpr-definitionList-definitionTitle">
                    {{ 'AutomationAgents.agent.summary.createdBy' | localize }}
                </div>
                <div class="agpr-definitionList-definition">
                    {{ (createdBy$ | async) ?? ('AutomationAgents.notAvailable' | localize) }}
                </div>

                <div class="agpr-definitionList-definitionTitle">
                    {{ 'AutomationAgents.agent.summary.createdDate' | localize }}
                </div>
                <div class="agpr-definitionList-definition">
                    {{ agent.createdDate | changeTimeZone: (userTimeZone$ | async) : 'MMMM Do, YYYY h:mm A z' }}
                </div>

                <div class="agpr-definitionList-definitionTitle">
                    {{ 'AutomationAgents.agent.summary.lastModifiedBy' | localize }}
                </div>
                <div class="agpr-definitionList-definition">
                    {{ (lastModifiedBy$ | async) ?? ('AutomationAgents.notAvailable' | localize) }}
                </div>

                <div class="agpr-definitionList-definitionTitle">
                    {{ 'AutomationAgents.agent.summary.lastModifiedDate' | localize }}
                </div>
                <div class="agpr-definitionList-definition">
                    @if (agent.lastModifiedDate) {
                        {{ agent.lastModifiedDate | changeTimeZone: (userTimeZone$ | async) : 'MMMM Do, YYYY h:mm A z' }}
                    } @else {
                        {{ 'AutomationAgents.notAvailable' | localize }}
                    }
                </div>

                <div class="agpr-definitionList-definitionTitle">
                    {{ 'AutomationAgents.agent.summary.type' | localize }}
                </div>
                <div class="agpr-definitionList-definition">
                    {{ 'AutomationAgents.agent.summary.type.curation' | localize }}
                </div>

                <div class="agpr-definitionList-definitionTitle">
                    {{ 'AutomationAgents.agent.summary.lastActivity' | localize }}
                </div>
                <div class="agpr-definitionList-definition">
                    @if (agent.lastModifiedDate) {
                        {{ agent.lastModifiedDate | changeTimeZone: (userTimeZone$ | async) : 'MMMM Do, YYYY h:mm A z' }}
                    } @else {
                        {{ 'AutomationAgents.notAvailable' | localize }}
                    }
                </div>

                <!-- The custom prompt the agent evaluates mentions against, and nothing else -->
                <div class="agpr-definitionList-definitionTitle">
                    {{ 'AutomationAgents.agent.summary.prompt' | localize }}
                </div>
                <div class="agpr-definitionList-definition">
                    @if (prompt) {
                        <div class="agpr-agentSummary-promptName">{{ prompt.name }}</div>
                        <div>{{ prompt.prompt }}</div>
                    } @else {
                        {{ 'AutomationAgents.notAvailable' | localize }}
                    }
                </div>

                @if (actions.length) {
                    <div class="agpr-definitionList-definitionTitle">
                        {{ 'AutomationAgents.agent.summary.actions' | localize }}
                    </div>
                    <div class="agpr-definitionList-definition">
                        <ul class="agpr-agentSummary-actions">
                            @for (action of actions; track $index) {
                                <li class="agpr-agentSummary-action">
                                    <span
                                        class="agpr-agentSummary-actionIcon"
                                        [ngClass]="action.icon"
                                        aria-hidden="true"
                                    ></span>
                                    <span class="agpr-agentSummary-actionLabel">
                                        {{ 'AutomationAgents.action.card.' + action.type | localize }}{{ action.detailLabel ? ':' : '' }}
                                    </span>
                                    @if (action.detailLabel) {
                                        <span class="agpr-agentSummary-actionDetail">{{ action.detailLabel }}</span>
                                    }
                                </li>
                            }
                        </ul>
                    </div>
                }
            </div>
        </agpr-panel>
    </section>
}
